import { useState } from "react";
import { ModalAlert } from "core/lib/show-modal";

const useFileManager = (initialValue: any) => {
  const [uploadedFiles, setUploadedFiles] = useState(initialValue);
  const [runningFileSize, setRunningFileSize] = useState(0);

  const checkTotalSize = (file: any) => {
    //byte to kb = 1024
    //size limit = 20000kb

    const kb = 1024;
    const sizeLimit = 20000;
    // const sizeLimit = 2560;

    const currentTotal = runningFileSize + file.size;

    if (currentTotal / kb > sizeLimit) {
      return true;
    }

    setRunningFileSize(currentTotal);

    return false;
  };

  //handling the file attachment
  function handleAttachmentChange(files: any) {
    const supportedFormats = ["application/pdf", "image/png", "image/jpeg"];

    const file = files[0];

    if (!file) {
      console.error("File error");
      return;
    }

    const isSupported = supportedFormats.includes(file.type);

    //check if the file name doesn't exists already
    if (uploadedFiles && uploadedFiles.length > 0) {
      const existingFile = uploadedFiles.filter((f: any) => f.name === file.name);

      if (existingFile.length > 0) {
        return;
      }
    }

    if (!isSupported) {
      ModalAlert.error(`Sorry, we only accept files with specific formats. 
      Please choose a different file that is a jpg, pdf, or png`, "Cannot upload attachment");
      return;
    }

    const overSize = checkTotalSize(file);

    if (overSize) {
      ModalAlert.error("There is a file limit of 20MB", "Cannot upload attachment");
      return;
    }

    //setting the file name
    setUploadedFiles([
      ...uploadedFiles,
      {
        name: file.name,
        size: file.size,
        overSize,
        file: file,
        notSupported: !isSupported
      },
    ]);
  }

  const reloadAttachment = (file: any) => {
    //check if the file size allows you to reload the file

    //check if the file name doesn't exists already
    if (uploadedFiles.length > 0) {
      const existingFile = uploadedFiles.filter((f: any) => f.name === file.name);

      if (existingFile.length > 0) {
        const file = existingFile[0];
        const isOverSize = checkTotalSize(file);

        if (!isOverSize) {
          setUploadedFiles(
            uploadedFiles.map((obj: any) =>
              obj.name === file.name ? { ...obj, overSize: isOverSize } : obj
            )
          );
        }

        return;
      }
    }
  };

  const removeAttachmentHandler = (name: string) => {
    const file = uploadedFiles.filter(
      (file: any) => file.name === name && !file.overSize
    )[0];

    if (file) {
      setRunningFileSize((size) => size - file.size);
    }

    const remainingFiles = uploadedFiles.filter((file: any) => file.name !== name);
    setUploadedFiles(remainingFiles);
  };

  const resetUploadedFiles = () => {
    setUploadedFiles([]);
    setRunningFileSize(0);
  };

  return {
    handleAttachmentChange,
    uploadedFiles,
    reloadAttachment,
    removeAttachmentHandler,
    resetUploadedFiles,
  };
};

export default useFileManager;
